const LS_PREFIX = 'lpf_cache_';
const memoryFallback = new Map();

class CacheService {
  _lsGet(key) {
    try {
      const raw = localStorage.getItem(LS_PREFIX + key);
      if (!raw) return null;
      const { data, expiry } = JSON.parse(raw);
      if (Date.now() > expiry) {
        localStorage.removeItem(LS_PREFIX + key);
        return null;
      }
      return data;
    } catch {
      return null;
    }
  }

  _lsSet(key, data, ttlMs) {
    try {
      localStorage.setItem(
        LS_PREFIX + key,
        JSON.stringify({ data, expiry: Date.now() + ttlMs })
      );
      return true;
    } catch {
      return false;
    }
  }

  get(key) {
    const ls = this._lsGet(key);
    if (ls !== null) return ls;
    const mem = memoryFallback.get(key);
    if (mem && Date.now() < mem.expiry) return mem.data;
    return null;
  }

  set(key, data, ttlMs = 60 * 60 * 1000) {
    if (!this._lsSet(key, data, ttlMs)) {
      memoryFallback.set(key, { data, expiry: Date.now() + ttlMs });
    }
  }

  async getOrFetch(key, fetchFn, ttlMs = 60 * 60 * 1000) {
    const cached = this.get(key);
    if (cached !== null) return cached;
    const data = await fetchFn();
    this.set(key, data, ttlMs);
    return data;
  }

  remove(key) {
    try { localStorage.removeItem(LS_PREFIX + key); } catch {}
    memoryFallback.delete(key);
  }

  clearAll() {
    try {
      Object.keys(localStorage)
        .filter(k => k.startsWith(LS_PREFIX))
        .forEach(k => localStorage.removeItem(k));
    } catch {}
    memoryFallback.clear();
  }

  clear(key) { this.remove(key); }
}

const cacheService = new CacheService();
export default cacheService;